import { InputHTMLAttributes, forwardRef, useId } from "react";
import "./Input.css";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string | null;
  hint?: string;
  required?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, hint, required, id, className, ...rest }, ref) => {
    const generatedId = useId();
    const inputId = id ?? generatedId;
    const errorId = error ? `${inputId}-error` : undefined;
    const hintId = hint ? `${inputId}-hint` : undefined;

    return (
      <div className="nx-field">
        {label ? (
          <label className="nx-field__label" htmlFor={inputId}>
            {label}
            {required ? <span className="nx-field__required">*</span> : null}
          </label>
        ) : null}
        <input
          ref={ref}
          id={inputId}
          className={["nx-input", error ? "nx-input--error" : "", className].filter(Boolean).join(" ")}
          aria-invalid={error ? true : undefined}
          aria-describedby={[errorId, hintId].filter(Boolean).join(" ") || undefined}
          {...rest}
        />
        {hint && !error ? (
          <span id={hintId} className="nx-field__hint">
            {hint}
          </span>
        ) : null}
        {error ? (
          <span id={errorId} className="nx-field__error" role="alert">
            {error}
          </span>
        ) : null}
      </div>
    );
  },
);
Input.displayName = "Input";
